import { createAction } from '@reduxjs/toolkit';

const STORAGE_RESET = 'STORAGE_RESET';

export const storageResetAction = createAction(STORAGE_RESET);
